var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoStatusPending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FFB700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6025 13.3025H15.7954V7.34856C15.7954 6.60389 15.1696 6 14.3975 6C13.6258 6 13 6.60389 13 7.34856V14.6514C13 15.3965 13.6258 16 14.3975 16H20.6025C21.3742 16 22 15.3965 22 14.6514C22 13.9064 21.3742 13.3025 20.6025 13.3025Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoStatusPending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_status_pending.24c8a7360fac117992d48346bf1c2972.svg";